import newFeatureIcon from './newfeature.png';
import bannerBackground from './MSA_Textures-24.png';

export const getBannerStyles = (components, { palette = {} } = {}) => ({
  assetLibraryNewFeatureBanner: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 28,
    marginBottom: 20,
    backgroundColor: palette.themeLighterAlt,
    color: palette.neutralPrimary,
    fontSize: 14,
    lineHeight: '19px',
    fontWeight: 400,
    borderRadius: 6,

    '& .new-feature-icon': {
      flexGrow: 0,
      flexShrink: 0,
      width: 30,
      height: 31,
      backgroundSize: '100% 100%',
      backgroundImage: `url('${newFeatureIcon}')`,
      margin: 8,
    },

    '& .new-feature-label': {
      flexGrow: 0,
      flexShrink: 0,
      fontWeight: 600,
      marginRight: 4,
    },

    '& .new-feature-content': {
      flexGrow: 1,
      flexShrink: 1,
    },
  },

  assetLibraryAIGCPromotionBanner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '16px 16px 16px 10px',
    marginBottom: 20,
    gap: '6px',
    borderRadius: 4,
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
    overflow: 'hidden',

    '& .asset-library-aigc-banner-background': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: 'linear-gradient(90deg, #005A9F 0.16%, #883EE2 99.89%)',

      // put a translucent mask on top
      '&::before': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        content: '""',
        opacity: 0.6,
        backgroundImage: `url("${bannerBackground}")`,
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
      },
    },

    '& .asset-library-aigc-banner-content': {
      display: 'flex',
      flexDirection: 'row',
      zIndex: 1,

      '& .aigc-banner-icon': {
        flexShrink: 0,
        flexGrow: 0,
        marginRight: 6,
      },

      '& .aigc-banner-texts': {
        flexShrink: 1,
        flexGrow: 1,
        color: 'white',
        fontFamily: 'Segoe UI',
        fontStyle: 'normal',
        fontWeight: 600,
        marginRight: 16,

        '& .aigc-banner-title': {
          fontSize: 14,
          lineHeight: '20px',
        },

        '& .aigc-banner-description': {
          fontSize: 12,
          fontWeight: 400,
          lineHeight: '16px',
        },
      },
    },
  },
});

